import api from "./api";
export const nativeFeeds = () => api.get("/ujms/native-records/feeds");
export const nativeRecords = (params) => api.get("/ujms/native-records", { params });
export const createNativeRecord = (data) => api.post("/ujms/native-records", data);
export const editNativeRecord = (id, data) => api.put(`/ujms/native-records/${id}`, data);
export const reviewNativeRecord = (id, data) => api.post(`/ujms/native-records/${id}/review`, data);
export const nativeHistory = (id) => api.get(`/ujms/native-records/${id}/history`);
export const queryNativeRecords = (data) => api.post("/ujms/native-records/query", data);
export const previewReadiness = (id, data) => api.post(`/ujms/hearings/${id}/readiness`, data);
export const savePreparation = (id, data) => api.put(`/ujms/hearings/${id}/preparation`, data);